export enum WarrantyStatuses {
  ACTIVE = 'active',
  EXPIRED = 'expired',
  EXTENDED = 'extended',
  FUTURE = 'future',
}
